interface JwtBody {
    ForLegalIps: string | undefined;
    ForPersonOib: string | undefined;
    acr: string;
    aud: string;
    azp: string;
    email: string;
    email_verified: boolean;
    exp: number;
    iat: number;
    iss: string;
    jti: string;
    preferred_username: string;
    realm_access: {
        roles: string[];
    };
    resource_access: {
        "KingICT.eAdviser": {
            roles: string[];
        };
        account: {
            roles: string[];
        };
    };
    scope: string;
    session_state: string;
    sub: string;
    typ: string;
    NavToken?: string;
    MessageId?: string;
    ToLegalIps?: string;
    ToLegalIzvorReg?: string;
    ForLegalIzvorReg?: string;
    oib?: string;
    EPoljoprivredaGuid?: string;
    previous_login: string;
    role?: string;
    given_name?: string;
    family_name?: string;
}

export const decodeJwt = (jwt: string) => {
    const parts = jwt.split(".");
    const [, second] = parts;

    // Decode base64 and properly handle UTF-8 characters
    const base64Decoded = atob(second);
    const body: JwtBody = JSON.parse(
        decodeURIComponent(
            Array.from(base64Decoded)
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        )
    );
    return body;
};
